import { PipelineSeriesOnBuild, PipelineType } from '@nova/types';

import { StaticPipelineOperations } from './StaticPipelineOps';
import { TextureManipulation } from './texture-manipulation';

export class TextureManipulationDrawSeries extends TextureManipulation {
  public Draw(seriesBuilt: PipelineSeriesOnBuild): PipelineType {
    return StaticPipelineOperations.DrawPipelineSeriesToCanvas(this.pipelines, seriesBuilt);
  }
}
